import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import { alpha, darken, styled } from '@classify/react-core-components/styles';
import Image from 'next/image';
import { isAllowedUrl } from '@/modules/image';
import { useCourseContext } from '../_contexts/CourseContext';
import CourseMetadata from './CourseMetadata';
import FooterAction from './FooterAction';
import useCourseStatus from '../_hooks/useCourseStatus';
const Wrapper = styled('div')(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  display: 'flex',
  padding: spacing(5, 0),
  justifyContent: 'center',
  '& > img': {
    display: 'none'
  },
  [breakpoints.up('sm')]: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridGap: spacing(3)
  },
  [breakpoints.up('md')]: {
    alignItems: 'center',
    padding: 'unset',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridGap: spacing(3),
    '& > img': {
      display: 'block'
    }
  }
}));
const Title = styled(Typography)(({
  theme: {
    spacing
  }
}) => ({
  margin: spacing(1, 0)
}));
const Content = styled('div', {
  shouldForwardProp: prop => !['hideBorder'].includes(prop as string)
})<{
  hideBorder: boolean;
}>(({
  theme: {
    spacing,
    palette,
    breakpoints
  },
  hideBorder
}) => ({
  display: 'none',
  [breakpoints.up('sm')]: {
    borderRight: hideBorder ? 'none' : `1px solid ${palette.divider}`,
    paddingRight: spacing(2),
    marginRight: spacing(2),
    display: 'block'
  }
}));
function CourseFooter(t0) {
  const $ = _c(30);
  const {
    userId
  } = t0;
  const {
    course
  } = useCourseContext();
  const {
    isFinished
  } = useCourseStatus(course);
  const {
    title,
    illustration,
    categoryColor,
    category
  } = course;
  let t1;
  if ($[0] !== categoryColor) {
    t1 = darken(categoryColor, 0.05);
    $[0] = categoryColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const accessibleTitleColor = t1;
  let t2;
  if ($[2] !== categoryColor) {
    t2 = alpha(categoryColor, 0.08);
    $[2] = categoryColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const backgroundColor = t2;
  const ImageComponent = isAllowedUrl(illustration) ? Image : "img";
  let t3;
  if ($[4] !== backgroundColor) {
    t3 = {
      backgroundColor
    };
    $[4] = backgroundColor;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== ImageComponent || $[7] !== illustration) {
    t4 = <ImageComponent src={illustration} alt="" height={174} width={310} />;
    $[6] = ImageComponent;
    $[7] = illustration;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== accessibleTitleColor) {
    t5 = {
      color: accessibleTitleColor,
      textTransform: "uppercase"
    };
    $[9] = accessibleTitleColor;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== category || $[12] !== t5) {
    t6 = <Typography variant="subheadingSmall" component="p" style={t5}>{category}</Typography>;
    $[11] = category;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== title) {
    t7 = <Title variant="h4" component="h2">{title}</Title>;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Box><CourseMetadata /></Box>;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isFinished || $[18] !== t6 || $[19] !== t7) {
    t9 = <Content hideBorder={isFinished}>{t6}{t7}{t8}</Content>;
    $[17] = isFinished;
    $[18] = t6;
    $[19] = t7;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== userId) {
    t10 = <FooterAction userId={userId} />;
    $[21] = userId;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t4 || $[25] !== t9) {
    t11 = <ContentWrapper><Wrapper>{t4}{t9}{t10}</Wrapper></ContentWrapper>;
    $[23] = t10;
    $[24] = t4;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3) {
    t12 = <Box sx={t3}>{t11}</Box>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
export default CourseFooter;